import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


import SideBar from './Partials/Sections/SideBar/SideBar'
import NavBar from './Partials/Sections/NavBar/NavBar';

import Login from './Screens/AuthScreens/Login/Login';

import './App.css';
import Dashboard from './Screens/Dashboard/Dashboard';

import Sliders from './Screens/WebsiteContent/Sliders';
import WebsiteContentScreens from './Screens/WebsiteContent/WebsiteContentScreens';
import HomePartners from './Screens/WebsiteContent/HomePartners';
import HomeCounter from './Screens/WebsiteContent/HomeCounter';
import SocialLinks from './Screens/WebsiteContent/SocialLinks';

import Category from './Screens/OrganizationGroups/Category';
import OrganizationGroupScreens from './Screens/OrganizationGroups/OrganizationGroupsScreens';
import FeaturedCategory from './Screens/OrganizationGroups/FeaturedCategory';
import Subcategory from './Screens/OrganizationGroups/Subcategory';

import OrganizationScreens from './Screens/OrganizationScreens/OrganizationScreens';
import Organizations from './Screens/OrganizationScreens/Organizations/Organizations';

import PcOrganizationPhones from './Screens/OrganizationContacts/PcOrganizationPhones';
import PcOrganizationLinks from './Screens/OrganizationContacts/PcOrganizationLinks';
import PcOrganizationEmails from './Screens/OrganizationContacts/PcOrganizationEmails';
import OrganizationContacts from './Screens/OrganizationContacts/OrganizationContacts';

import OrganizationCards from './Screens/OrganizationCards/OrganizationCards';
import SubcatSectionCardScreens from './Screens/SectionsAndCards/SubcatSectionCardScreens';
import SubcategorySections from './Screens/SectionsAndCards/SubcategorySections';
import SubcategoryNDICards from './Screens/SectionsAndCards/SubcategoryCards/SubcategoryNDICards';
import SubcategoryNICards from './Screens/SectionsAndCards/SubcategoryCards/SubcategoryNICards';
import SubcategoryStatCards from './Screens/SectionsAndCards/SubcategoryCards/SubcategoryStatCard';
import OrganizationNDICards from './Screens/OrganizationCards/OrganizationNDICards';
import OrganizationStatCards from './Screens/OrganizationCards/OrganizationStatCards';
import OrganizationNICards from './Screens/OrganizationCards/OrganizationNICards';
import UsersScreens from './Screens/UsersScreens/UsersScreens';
// import Customers from './Screens/UsersScreens/Customers/Customers';
import Employees from './Screens/UsersScreens/Employees/Employees';
import InviteEmployees from './Screens/AuthScreens/InviteEmployees/InviteEmployees';
import RecoverPassOne from './Screens/AuthScreens/RecoverPassOne';
import RecoverPassThree from './Screens/AuthScreens/RecoverPassThree';
import MyProfile from './Screens/MyProfile/MyProfile';
import ChangePassword from './Screens/MyProfile/ProfileInfo/ChangePassword/ChangePassword';
import Register from './Screens/AuthScreens/Register/Register';
import Branches from './Screens/Branches/Branches';




function App() {

  const {employee} = useSelector(state => state.auth)
  
  return (
    <>
    <BrowserRouter>
      {employee && <NavBar />}
      <main>
          
          {employee && <SideBar />}

          <section className='screen-container'>
            <Routes>

              <Route path='/login' element={!employee ? <Login /> : <Navigate to={'/'} />} />
              <Route path='/register/:token' element={!employee ? <Register /> : <Navigate to={'/'} />} />
                
              <Route path={'/'} element={employee ? <Dashboard /> : <Navigate to={'/login'} />} />

              <Route path={'/categories'} element={employee ? <Category /> : <Navigate to={'/login'} />} />
              <Route path={'/featuredCategories'} element={employee ? <FeaturedCategory /> : <Navigate to={'/login'} />} />
              <Route path={'/subcategories'} element={employee ? <Subcategory /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationGroups'} element={employee ? <OrganizationGroupScreens /> : <Navigate to={'/login'} />} />
              
              <Route path={'/organizations'} element={employee ? <Organizations /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationScreens'} element={employee ? <OrganizationScreens /> : <Navigate to={'/login'} />} />
              
              <Route path={'/branches/:organizationID'} element={employee ? <Branches /> : <Navigate to={'/login'} />} />

              <Route path={'/organizationContacts/:organizationID'} element={employee ? <OrganizationContacts /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationPhones/:parentID'} element={employee ? <PcOrganizationPhones /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationLinks/:parentID'} element={employee ? <PcOrganizationLinks /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationEmails/:parentID'} element={employee ? <PcOrganizationEmails /> : <Navigate to={'/login'} />} />

              <Route path={'/organizationCards/:organizationID'} element={employee ? <OrganizationCards /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationStatCards/:parentID'} element={employee ? <OrganizationStatCards /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationNDICards/:parentID'} element={employee ? <OrganizationNDICards /> : <Navigate to={'/login'} />} />
              <Route path={'/organizationNICards/:parentID'} element={employee ? <OrganizationNICards /> : <Navigate to={'/login'} />} />

              <Route path={'/subcatSectionCardScreens/:subcategoryID'} element={employee ? <SubcatSectionCardScreens /> : <Navigate to={'/login'} />} />
              <Route path={'/subcategorySections/:parentID'} element={employee ? <SubcategorySections /> : <Navigate to={'/login'} />} />
              <Route path={'/subcategoryStatCards/:parentID'} element={employee ? <SubcategoryStatCards /> : <Navigate to={'/login'} />} />
              <Route path={'/subcategoryNDICards/:parentID'} element={employee ? <SubcategoryNDICards /> : <Navigate to={'/login'} />} />
              <Route path={'/subcategoryNICards/:parentID'} element={employee ? <SubcategoryNICards /> : <Navigate to={'/login'} />} />
              
              <Route path={'/websiteContents'} element={employee ? <WebsiteContentScreens /> : <Navigate to={'/login'} />} />
              <Route path={'/homePartners'} element={employee ? <HomePartners /> : <Navigate to={'/login'} />} />
              <Route path={'/homeCounters'} element={employee ? <HomeCounter /> : <Navigate to={'/login'} />} />
              <Route path={'/sliders'} element={employee ? <Sliders /> : <Navigate to={'/login'} />} />
              <Route path={'/socialLinks'} element={employee ? <SocialLinks /> : <Navigate to={'/login'} />} />

              <Route path={'/user_screens'} element={employee ? <UsersScreens /> : <Navigate to={'/login'} />} />
              {/* <Route path={'/customers'} element={employee ? <Customers /> : <Navigate to={'/login'} />} /> */}
              <Route path={'/employees'} element={employee ? <Employees /> : <Navigate to={'/login'} />} />
              <Route path={'/employee-invites'} element={employee ? <InviteEmployees /> : <Navigate to={'/login'} />} />

              <Route path="/recover-pass-one" element={<RecoverPassOne />} />
              <Route path="/resetEmployeePassword/:token" element={<RecoverPassThree />} />
              <Route path="/profile" element={employee ? <MyProfile /> : <Navigate to='/login' />} />
              <Route path="/change-password" element={employee ? <ChangePassword /> : <Navigate to='/login' />} />
              
            </Routes>
          </section>
          {/* </div> */}
      </main>
    </BrowserRouter> 
    </>  
  );
}

export default App;
